import { getHashCode } from 'owa-timestream-asset-sdk';
import type { LinkPayload } from '../schema';

export default function previewIsValid({ url, linkPreview, errorMessage }: LinkPayload) {
    return (
        !!url &&
        ((!!linkPreview && !!linkPreview.Id && getHashCode(url) == linkPreview.Id) ||
            !!errorMessage)
    );
}
